module.exports = __webpack_public_path__ + "img/icon.ec0aab43.png";